// extracted by mini-css-extract-plugin
export default {"right":"layout_right__+Gli2","wrapper":"layout_wrapper__hpqtX","cover":"layout_cover__RYg+H","sider":"layout_sider__VhQxT"};